<template lang="pug">
    mixin brand-menu
        div.column(v-for="i in brands")
            router-link.brand-logo(:to="$t('page_04.url') + '/' + i.id")
                img.is-block(:src="'https://bo.herdadesaomiguel.com/assets/gamas/' + i.imagem", v-if="isOpaque")
                img.is-block(:src="'https://bo.herdadesaomiguel.com/assets/gamas/' + i.imagem.replace('.svg', '_white.svg')", v-else)

    nav#navbar.navbar.is-fixed-top(:class="{ 'is-opaque': isOpaque || navbarMobileExpanded }", @mouseover="isOpaque = true", @mouseleave="checkRoute")
        div.navbar-brand.is-hidden-desktop
            // router-link(to="/")
            //     img.cr-logo(src="../assets/logo-blue.svg", alt="casa-relvas-logo")
            div.cr-logo-mobile.has-text-centered(:class="{ 'is-opaque': isOpaque }")
                router-link(to="/")
                    img(src="../assets/logo-blue.svg", alt="casa-relvas-logo")

            a.navbar-burger(:class="{ 'is-active': navbarMobileExpanded }", @click="navbarMobileExpanded = !navbarMobileExpanded")
                span
                span
                span

        //- navbar * mobile *
        div.navbar-menu.has-text-blue.is-hidden-desktop(:class="{ 'is-active': navbarMobileExpanded }")
            div.columns
                // div.cr-logo.column.is-2.has-text-centered
                //     router-link(to="/")
                //         img(src="../assets/logo-blue.svg", alt="casa-relvas-logo")
                div.column.has-text-centered
                    router-link.link(tag="span", :to="$t('navbar.item_1.url')", :class="{ 'router-link-active': subnav === 1}")
                        a.is-uppercase {{ $t('navbar.item_1.name') }}
                div.column.has-text-centered
                    router-link.link(tag="span", :to="$t('navbar.item_2.url') + '/' + brandid", :class="{ 'router-link-active': subnav === 2}")
                        a.is-uppercase {{ $t('navbar.item_2.name') }}
                div.column.has-text-centered
                    router-link.link(tag="span", :to="$t('navbar.item_3.url')")
                        a.is-uppercase {{ $t('navbar.item_3.name') }}
                div.column.has-text-centered
                    router-link.link(tag="span", :to="$t('navbar.item_4.url')")
                        a.is-uppercase {{ $t('navbar.item_4.name') }}
                div.column.has-text-centered
                    router-link.link(tag="span", :to="$t('navbar.item_5.url')")
                        a.is-uppercase {{ $t('navbar.item_5.name') }}
                div.column.has-text-centered
                    div.lang-menu
                        div.is-inline-block(@click="lang = !lang")
                            span.is-uppercase {{ $i18n.locale }}
                            i.fas.fa-angle-down.fa-lg

                        ul.lang-menu-list(v-if="lang")
                            li.lang-menu-item.is-pointer(v-for="locale in locales", :key="locale.code", @click="$i18n.locale = locale.code; lang = false") {{ locale.name }}

                div.column.has-text-centered.is-narrow
                    router-link.link.has-margin-left(tag="span", :to="$t('page_08.url')")
                        div.search-icon.has-text-weight-light.is-pointer
                            i.fas.fa-search.has-text-blue
        div.navbar-menu.is-hidden-desktop(:class="{ 'is-active': navbarMobileBrands }")
            div.container
                div.columns.is-marginless.is-mobile.is-multiline.is-centered
                    div.column.is-2(v-for="i in brands")
                        router-link.brand-logo(:to="$t('page_04.url') + '/' + i.id")
                            img.is-block(:src="'https://bo.herdadesaomiguel.com/assets/gamas/' + i.imagem")

        //- navbar * desktop *
        div.navbar-menu.navbar-desktop(:class="{ 'has-text-blue': isOpaque || colored }")
            div.navbar-desktop(:class="{ 'has-border-bottom': subnav }")
                div.container
                    div.columns.is-gapless
                        div.column
                            div.columns.is-gapless.is-fullheight
                                div.column(@mouseover="subnav = 1")
                                    router-link.link(tag="span", :to="$t('navbar.item_1.url')", :class="{ 'router-link-active': subnav === 1}")
                                        a.is-uppercase {{ $t('navbar.item_1.name') }}
                                div.column.has-text-centered(@mouseover="subnav = 2")
                                    router-link.link(tag="span", :to="$t('navbar.item_2.url') + '/' + brandid", :class="{ 'router-link-active': subnav === 2}")
                                        a.is-uppercase {{ $t('navbar.item_2.name') }}
                                div.column.has-text-right(@mouseover="subnav = null")
                                    router-link.link(tag="span", :to="$t('navbar.item_3.url')")
                                        a.is-uppercase {{ $t('navbar.item_3.name') }}
                        div.cr-logo.column.is-2.has-text-centered(@mouseover="subnav = null")
                            router-link(to="/")
                                img(src="../assets/logo-blue.svg", alt="casa-relvas-logo", v-if="isOpaque || colored")
                                img(src="../assets/logo-white.svg", alt="casa-relvas-logo", v-else)
                        div.column
                            div.columns.is-gapless.is-fullheight
                                div.column(@mouseover="subnav = null")
                                    router-link.link(tag="span", :to="$t('navbar.item_4.url')")
                                        a.is-uppercase {{ $t('navbar.item_4.name') }}
                                div.column.has-text-centered(@mouseover="subnav = null")
                                    router-link.link(tag="span", :to="$t('navbar.item_5.url')")
                                        a.is-uppercase {{ $t('navbar.item_5.name') }}
                                div.column.has-text-centered.is-narrow(@mouseover="subnav = null")
                                    div.dropdown.is-hoverable(@mouseleave="lang = false")
                                        div.dropdown-trigger(@mouseover="lang = true")
                                            span.dropdown-middle.is-pointer(:class="{ 'is-colored': lang }")
                                                span.is-uppercase {{ $i18n.locale }}
                                                i.fas.fa-angle-down.fa-lg
                                        div.dropdown-menu
                                            div.dropdown-content
                                                ul
                                                    li.is-pointer(v-for="locale in locales", :key="locale.code", @click="$i18n.locale = locale.code") {{ locale.name }}
                                div.column.is-narrow(@mouseover="subnav = null")
                                    router-link.link.has-margin-left(tag="span", :to="$t('page_08.url')")
                                        div.search-icon.has-text-weight-light.is-pointer
                                            i.fas.fa-search

            //-- subnav
            div.subnav(id="subnavbar", v-if="subnav", @mouseleave="checkRoute")

                //- subnav casa relvas
                div.subnav-fam.container(v-if="subnav === 1")
                    div.columns.is-centered
                        div.column.has-text-centered(v-for="i in $t('navbar.item_1.subnav.links')")
                            router-link(:to="i.url") {{ i.name }}

                //- subnav brands
                div.container(v-if="subnav === 2")
                    div.columns.is-marginless
                        +brand-menu
</template>

<script>
export default {
    name: 'navbar',
    props: {
        opaque: {
            type: Boolean,
            default: false
        },
        colored: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            isOpaque: this.opaque,
            subnav: null,
            locales: [
                {
                    code: 'pt',
                    name: 'PT'
                },
                {
                    code: 'en',
                    name: 'EN'
                }
            ],
            brands: [],
            lang: false,
            brandid: null,
            navbarMobileExpanded: false,
            navbarMobileBrands: false
        }
    },
    mounted () {
        this.navbarMobileBrands = this.$route.name === 'wines'
    },
    watch: {
        $route () {
            this.checkRoute()
        }
    },
    created () {
        window.addEventListener('scroll', this.checkRoute)
        this.getBrands()
        this.checkRoute()
    },
    methods: {
        async getBrands () {
            this.brands = await this.$api.getBrands()
            this.brandid = this.brands[0].id
        },
        checkRoute () {
            const subnavPaths = {
                _1: [ 'family', 'origin', 'vision', 'terroir', 'team' ],
                _2: [ 'wines' ]
            }

            if (subnavPaths._1.includes(this.$route.name)) {
                this.subnav = 1
            } else if (subnavPaths._2.includes(this.$route.name)) {
                this.subnav = 2
                this.isOpaque = true
            } else {
                this.subnav = null
            }

            this.isOpaque = this.opaque || window.scrollY > 250
        }
    }
}
</script>

<style lang="stylus" scoped>

$blue = #1d3763

.navbar-menu
    box-shadow none

    @media screen and (max-width 768px)
        overflow hidden !important
        // box-shadow: 0px 2px 50px rgba(216, 222, 229, 0.5)
        padding 45px 0 30px 0

.navbar-burger:hover
    background-color transparent

.lang-menu
    i
        margin-left 10px

    &-list
        margin-top 10px

    &-item
        margin-bottom 10px
.is-fullheight
    height 100%

.dropdown
    height 100%

    .dropdown-trigger
        min-width 5rem

        .dropdown-middle
            height 100%
            display inline-flex
            align-items center
            justify-content center
            border-bottom 2px solid transparent

            span + i
                margin-left 10px

            &.is-colored
                border-color $blue

    .dropdown-menu
        min-width inherit
        width 100%
        padding-top 0

        .dropdown-content
                border-radius 0
                box-shadow none
                padding 1rem 0

                li + li
                    margin-top 1rem

.subnav
    a:hover
        font-weight 600

.has-border-bottom
    border-bottom: 2px solid rgba(245, 246, 248, 0.2)

.navbar
    background-color transparent

    .router-link-active, li:hover
        font-weight 600
        border-color white

    .has-text-blue
        .has-border-bottom
            border-bottom: 2px solid rgba(29, 55, 99, 0.1)

        a, i, span
            color $blue

        .router-link-active
            font-weight 600
            border-color $blue

    // &.is-opaque
    //     box-shadow: 0px 2px 50px rgba(216, 222, 229, 0.5)
    //     border-color transparent
    //     background-color white

    //     span:hover
    //         border-color: $blue
    //         a
    //             color: $blue

    //     .router-link-active
    //         border-color $blue

    &-desktop
        @media screen and (min-width 1025px)
            display block

        margin 0 auto

        font-size: 13px

        a
            color white
            letter-spacing 0.05em

        span, i
            color: white

.is-opaque
    @media screen and (min-width 1025px)
        box-shadow: 0px 2px 50px rgba(216, 222, 229, 0.5)

    border-color transparent
    background-color white

    span:hover
        border-color: $blue
        a
            color: $blue

    .router-link-active
        border-color $blue

.link
    height 100%
    display inline-flex
    align-items: center
    margin-bottom: -2px
    border-bottom: 2px solid transparent

    &:hover
        font-weight 600
        border-color: white
        a
            color: white

.cr-logo
    margin 0 1rem !important

    img
        width 6.25rem
        padding 1rem 0

.cr-logo-mobile
    position absolute
    top 0
    left 0
    margin 0 auto
    width 100%

    img
        width 5rem
        padding 1rem 0

.brand-logo
    img
        max-width 5rem

    &.router-link-exact-active img
        box-shadow: 0px 2px 25px rgba(216, 222, 229, 0.8)
        border-radius 50%

    :hover
        box-shadow: 0px 2px 25px rgba(216, 222, 229, 0.8)
        border-radius 50%

.subnav-fam
    padding 1.5rem 0

    .column
        padding 2rem 0

.search-icon
    height 100%
    display flex
    align-items center

.has-margin-left
    margin-left 1rem

</style>
